<template>
  <InitialPage />
</template>

<script>
  import InitialPage from './pages/InitialPage.vue';
  import {mapActions} from 'vuex';

  export default {
    name: 'App',

    components:{
      InitialPage
    },

    methods:{
      ...mapActions('stations',['Get_Hydrometereological_Stations',
                              'Get_Non_Telemetric_Metereological_Stations',
                              'Get_Accelerographic_Stations',
                              'Get_Phreatrimetric_Stations',
                              'Get_Airquality_Stations'])
    },

    created() {
        this.Get_Hydrometereological_Stations();

        this.Get_Non_Telemetric_Metereological_Stations();

        this.Get_Accelerographic_Stations();

        this.Get_Phreatrimetric_Stations();

        this.Get_Airquality_Stations();
    }
  };
</script>